module.exports = __webpack_public_path__ + "static/media/withdraw.629d61df.svg";